import { INTELLIGENT_PHOTO_CAPTURE_POST_PRTC_DETAILS_FAILURE, INTELLIGENT_PHOTO_CAPTURE_POST_PRTC_DETAILS_REQUEST, INTELLIGENT_PHOTO_CAPTURE_POST_PRTC_DETAILS_SUCCESS } from '../actions';
export const photoCaptureIntelligentPrtcDetailsReducer = (state, action) => {
    var _a;
    switch (action.type) {
        case INTELLIGENT_PHOTO_CAPTURE_POST_PRTC_DETAILS_REQUEST:
            return Object.assign(Object.assign({}, state), { isLoading: true });
        case INTELLIGENT_PHOTO_CAPTURE_POST_PRTC_DETAILS_SUCCESS: {
            const prtcData = action.payload.response;
            const existingPrtcs = ((_a = state.prtcDetailsData) === null || _a === void 0 ? void 0 : _a.prtcs) || [];
            const seenPrtcCodes = new Set(existingPrtcs.map(item => item.prtc));
            const newPrtcs = (prtcData.Prtcs || []).reduce((acc, prtc) => {
                if (!seenPrtcCodes.has(prtc.Prtc)) {
                    seenPrtcCodes.add(prtc.Prtc);
                    acc.push({
                        prtc: prtc.Prtc,
                        descriptions: {
                            en: prtc.Descriptions.En,
                            fr: prtc.Descriptions.Fr
                        }
                    });
                }
                return acc;
            }, []);
            const mergedPrtcDetailsData = {
                prtcs: [...existingPrtcs, ...newPrtcs]
            };
            const newState = Object.assign(Object.assign({}, state), { isLoading: false, prtcDetailsData: mergedPrtcDetailsData });
            return newState;
        }
        case INTELLIGENT_PHOTO_CAPTURE_POST_PRTC_DETAILS_FAILURE:
            return Object.assign(Object.assign({}, state), { isLoading: false, failureMessage: action.payload.failureMessage });
        default:
            return state;
    }
};
//# sourceMappingURL=photoCaptureIntelligentPrtcDetailsReducer.js.map